import { useMemo, useState } from 'react';
import { Menu } from '@headlessui/react';
import { Market } from '@utils/market/markets';
import { MARKET_LINKS } from '@utils/common';
import Icon from '@ui/components/icon/icon';

const MarketSelector = () => {
  const [market, setMarket] = useState<Market>('se');

  const marketName = useMemo(() => {
    return market === 'se' ? 'Sverige' : 'Norge';
  }, [market]);

  const marketIcon = useMemo(() => {
    return market === 'se' ? (
      <Icon name="sweden" size={12} className="rounded-full" />
    ) : (
      <Icon name="norway" size={12} className="rounded-full" />
    );
  }, [market]);

  return (
    <Menu as="div" className="relative inline-block text-left">
      {({ open }) => (
        <>
          <Menu.Button className="flex items-center gap-1 ">
            {marketIcon}
            {marketName}
            <Icon name="chevron" className={open ? '' : 'rotate-180'} />
          </Menu.Button>
          <Menu.Items className="absolute bottom-full right-0 mb-2 flex w-48 flex-col divide-y border outline-none">
            {MARKET_LINKS.map(({ href, label }) => (
              <Menu.Item
                as="a"
                key={href}
                href={href}
                className="flex items-center gap-2 bg-white p-4 hover:bg-beige focus:bg-beige active:bg-beige">
                {label === 'Sverige' && (
                  <Icon name="sweden" size={18} className="rounded-full" />
                )}
                {label === 'Norge' && (
                  <Icon name="norway" size={18} className="rounded-full" />
                )}
                {label}
              </Menu.Item>
            ))}
          </Menu.Items>
        </>
      )}
    </Menu>
  );
};

MarketSelector.displayName = 'MarketSelector';

export default MarketSelector;
